<template>
    <section class="main-box-vc">
        <div class="table-cell">
            <div class="main-box">
                <div class="main-box-content">
                    <h3>PISD Stadium</h3>
                    <h3>Champions Walk</h3>
                    <h4>REMEMBER THE PAST, PAVE THE WAY FOR THE FUTURE</h4>
                    <router-link to="/about" class="btn btn-danger">GET STARTED</router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script type="text/jsx">
    export default {
        name: 'home'
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// Home.vue?6e415a0a